import { render, staticRenderFns } from "./CustaModal.vue?vue&type=template&id=2a968c94&"
import script from "./CustaModal.vue?vue&type=script&lang=js&"
export * from "./CustaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports